import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/container';
import { Connection } from '@domain/connection/models/Connection';
import { Connector } from '@domain/connection/models/Connector';
import { ClientType } from '@domain/connection/models/Connector';

export const useImport4YouConnector = () => {
    const { data: connector, isLoading, error } = useQuery<Connector | undefined>({
        queryKey: ['import4you-connector'],
        queryFn: async () => {
            const result = await container.marketplaceRepository.fetchConnectors();
            if (result.status === 'error') throw new Error(result.error.message);
            return result.data.find(connector => connector.type === 'import4you');
        }
    });

    return {
        connector,
        isLoading,
        error
    };
};

export const useImport4YouConnections = () => {
    const { data: connections, isLoading, error } = useQuery<Connection[]>({
        queryKey: ['import4you-connections'],
        queryFn: async () => {
            const result = await container.marketplaceRepository.fetchConnections();
            if (result.status === 'error') throw new Error(result.error.message);
            return result.data.filter(connection => connection.connector.type === ClientType.IMPORT4YOU);
        }
    });

    return {
        connections: connections || [],
        isLoading,
        error
    };
};

export const useImport4YouInventory = (connectionId?: string) => {
    const { data: inventoryData, isLoading, error } = useQuery({
        queryKey: ['import4you-inventory', connectionId],
        queryFn: async () => {
            if (!connectionId) return null;
            const result = await container.import4YouConnectorRepository.fetchInventory(connectionId);
            if (result.status === 'error') throw new Error(result.error.message);
            return result.data;
        },
        enabled: !!connectionId
    });

    return {
        inventory: inventoryData || [],
        isLoading,
        error
    };
};

export const useImport4YouProductsInventory = (connectionId?: string) => {
    const { data: productsInventory, isLoading, error } = useQuery({
        queryKey: ['import4you-products-inventory', connectionId],
        queryFn: async () => {
            if (!connectionId) return [];
            const result = await container.import4YouConnectorRepository.fetchProductsInventory(connectionId);
            if (result.status === 'error') throw new Error(result.error.message);
            return result.data || [];
        },
        enabled: !!connectionId
    });

    return {
        productsInventory: productsInventory || [],
        isLoading,
        error
    };
};
